/* eslint-disable no-unused-vars */
import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { DeveloperChartView } from 'src/core/models'

interface DevelopersChartViewSelectorProps {
  keySelected: DeveloperChartView
  handleChange: (value: DeveloperChartView) => void
}

const DevelopersChartViewSelector: React.FC<DevelopersChartViewSelectorProps> = (props) => {
  const { t } = useTranslation()

  return <Select
    className='full-width'
    value={props.keySelected}
    onChange={(value: DeveloperChartView) => props.handleChange(value)}
  >
    <Select.Option value='COMPENSATED'>{t('general.Offset')}</Select.Option>
    <Select.Option value='AMOUNT'>{t('general.Amount')}</Select.Option>
  </Select>
}

export default DevelopersChartViewSelector
